import { useFieldContext, FieldErrors } from '../';
import { TextAreaV2, TextAreaV2Props, Label } from '../../Elements';

type TextAreaFieldProps = {
	label?: string;
} & Omit<TextAreaV2Props, 'value' | 'onChange' | 'onBlur' | 'error'>;

export const TextAreaField = ({ label, required, ...props }: TextAreaFieldProps) => {
	const field = useFieldContext<string>();

	// hide the error messages until the field has been touched
	// only show errors after initial blur to prevent the error from displaying when first typing, meta.isBlurred is set to true after initial blur
	const hideErrors = !field.state.meta.isTouched || !field.state.meta.isBlurred;
	const hasErrors = field.state.meta.errors.length > 0 && !hideErrors;

	return (
		<>
			<Label htmlFor={field.name} label={label} required={required} className='mb-2' />
			<TextAreaV2
				value={field.state.value}
				onChange={(e) => field.handleChange(e.target.value)}
				onBlur={field.handleBlur}
				{...props}
				name={field.name}
				id={field.name}
				hasErrors={hasErrors}
			/>
			<FieldErrors meta={field.state.meta} name={field.name} hideErrors={hideErrors} />
		</>
	);
};
